// ** Next Import
import { Link } from 'react-router-dom'

// ** MUI Imports
import Box from '@mui/material/Box'
import { styled } from '@mui/material/styles'

// ** Type Import
import { LayoutProps } from 'src/@core/layouts/types'
import EmpresaSelect from './EmpresaSelect'
import {Grid, Stack} from "@mui/material";
import NewCompany from "./NewCompany";

interface Props {
  hidden: LayoutProps['hidden']
  settings: LayoutProps['settings']
  saveSettings: LayoutProps['saveSettings']
  appBarContent: NonNullable<NonNullable<LayoutProps['horizontalLayoutProps']>['appBar']>['content']
  appBarBranding: NonNullable<NonNullable<LayoutProps['horizontalLayoutProps']>['appBar']>['branding']
}

const LinkStyled = styled(Link)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  textDecoration: 'none',
  marginRight: theme.spacing(8)
}))

const AppBarContent = (props: Props) => {
  // ** Props
  const { appBarContent: userAppBarContent, appBarBranding: userAppBarBranding } = props
  
  return (
    <Stack direction={'row'} alignItems={'center'} justifyContent={'space-between'} sx={{width:'100%'}}>
      {userAppBarBranding ? (
        userAppBarBranding(props)
      ) : (
          <Grid container sx={{width: '60%'}} alignItems={'center'} spacing={6}>
            <Grid item xs={2}>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'left' }}>
                <LinkStyled to='/'>
                  <img
                    src={`/images/fogaba-resized.png`}
                    height={'60'}
                    alt={`logo-img`}
                  />
                </LinkStyled>
              </Box>
            </Grid>
            <Grid item xs={6}>
              <EmpresaSelect/> 
            </Grid>
            <Grid item xs={5}>
              <NewCompany/>
            </Grid>
          </Grid>
      )}
      {userAppBarContent ? userAppBarContent(props) : null}
    </Stack>
  )
}

export default AppBarContent
